import { BrandLogo } from '@/components/brand/BrandLogo';

export default function Splash() {
  return (
    <div className="launch-screen">
      <div className="launch-screen__halo launch-screen__halo--primary" aria-hidden="true" />
      <div className="launch-screen__halo launch-screen__halo--secondary" aria-hidden="true" />
      <div className="launch-screen__grain" aria-hidden="true" />
      <div className="launch-screen__content">
        <div className="launch-screen__logo-wrap">
          <BrandLogo size={132} className="launch-screen__logo text-terre" title="La Fête" />
        </div>
        <div className="launch-screen__copy">
          <span className="launch-screen__eyebrow">La Fête</span>
          <p className="launch-screen__title">Votre carnet de sorties</p>
          <p className="launch-screen__subtitle">Près de vous, au bon moment.</p>
        </div>
      </div>
    </div>
  );
}
